import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserSettings } from '@shared';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserPreferencesService {
  private userPreferencesPath: string = `${environment.apiBasePath}${environment.userPreferencesPath}`;

  constructor(private http: HttpClient) {}

  public getUserPreferences(userId: string): Observable<UserSettings> {
    return this.http.get<UserSettings>(`${this.userPreferencesPath}/${userId}`);
  }

  public update(userId: string, settings: UserSettings): Observable<UserSettings> {
    return this.http.put<UserSettings>(`${this.userPreferencesPath}/${userId}`, settings);
  }
}
